var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "new-page-base",
    {
      attrs: { showBackText: "Faturas" },
      on: {
        back: function($event) {
          _vm.$router.push({ name: "billing-main-page" })
        }
      }
    },
    [
      _c("template", { attrs: { slot: "titleLeft" }, slot: "titleLeft" }, [
        _c("img", {
          staticClass: "logistic-provider-logo",
          attrs: {
            src: _vm.logisticProviderLogo,
            alt: _vm.logisticProviderName
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-content" },
        [
          _c("billing-filter-area", {
            on: { onFilterChange: _vm.refreshValues }
          }),
          _vm._v(" "),
          _c("billings-totalizers", { attrs: { totalizers: _vm.totalizers } }),
          _vm._v(" "),
          !_vm.loadingBillingDetails
            ? _c(
                "section",
                { staticClass: "page-content__details" },
                _vm._l(_vm.logisticProviderBillingDetails, function(
                  billing,
                  k
                ) {
                  return _c("single-billing-detail", {
                    key: k,
                    attrs: { detail: billing }
                  })
                })
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6397fd74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6397fd74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/detail/PageLPBillingsDetail.vue
// module id = null
// module chunks = 